module.exports = __webpack_public_path__ + "static/media/Line-Up_Review_Paciente_4.135f614f.jpg";